import { render, staticRenderFns } from "./welcome-sign-subscription-agreement.vue?vue&type=template&id=c95a083e&scoped=true&"
import script from "./welcome-sign-subscription-agreement.vue?vue&type=script&lang=js&"
export * from "./welcome-sign-subscription-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95a083e",
  null
  
)

export default component.exports